export default "__VITE_ASSET__Bb41Lz2S__"